import React from 'react'
import Link from 'gatsby-link'
import EmailIcon from 'react-icons/lib/ti/mail'
import GithubIcon from 'react-icons/lib/ti/social-github'
import LinkedinIcon from 'react-icons/lib/ti/social-linkedin'
import styled from 'styled-components'

const AnchorStyle = styled.a`
  color: black; 
  &:visited {
    color: black;
  }
`;
const ListLink = props =>
  <li style={{ display: `inline-block`, marginRight: `1rem` }}>
    <Link to={props.to}>
      {props.children}
    </Link>
  </li>;

export default ({ children }) =>
  <div style={{ 
    margin: `3rem auto`,
    maxWidth: 800,
    padding: `1.25rem 1rem` }}>
    <header style={{ marginBottom: `1.5rem` }}>
      <ul style={{ listStyle: `none`, float: `right` }}>
        <AnchorStyle href="mailto:manuel.matthew90@gmail.com"><EmailIcon size={50}/></AnchorStyle>
        <AnchorStyle href="https://github.com/mattmanuel90"><GithubIcon size={50} style={{marginTop:"10px"}} /></AnchorStyle>
        <AnchorStyle href="https://www.linkedin.com/in/matthewmanuel/"><LinkedinIcon size={50}/></AnchorStyle>
      </ul>
    </header>

    {children()}
  </div>


// WEBPACK FOOTER //
// ./src/layouts/index.js